<!--Proposal Creation/Submission by IA-->
<!-- Implementing Agency Details Form-->
<section class="right-side p-5" *ngIf="currentStep === 1">
  <h2>Implementing Agency Details Form <cite title="Source Title"></cite></h2>
  <div class="section">
    <div class="row">
      <div class="col-12 col-lg-12">
        <div class="shadow-2-strong card-registration">
          <div class="card-body p-4">
            <form [formGroup]="Implementing_Agency_DetailsForm">
              <div class="row">
                <div class="col-md-3 mb-2">
                  <label class="text-dark">Intervention Name<span class="text-danger">*</span></label>
                  <!--<select class="form-select" formControlName="interventionId" (change)="GetComponent($event, 'select')">
                    <option value="">-- Select Intervention --</option>
                    <option *ngFor="let In of Intervention_help" [value]="In.id">{{ In.text }}</option>
                  </select>-->
                  <ng-select [items]="Intervention_help"
                             bindLabel="text"
                             bindValue="id"
                             formControlName="interventionId"
                             [searchable]="true"
                             placeholder="--select--"
                             (change)="GetComponent($event, 'select')">
                  </ng-select>

                  <div *ngIf="ImplementingAgencyDetailsFormSubmitted && f['interventionId']['errors']"
                       class="text-danger">
                    <div *ngIf="f['interventionId'].errors['required']">Intervention is required</div>
                  </div>

                </div>
                <div class="col-md-6 mb-2">
                  <label class="text-dark">Component Name<span class="text-danger">*</span></label>
                  <!--<select class="form-select" formControlName="componentId" (change)="GetApprovedBudgetTargetMSME($event)">
                    <option value="">-- Select Component --</option>
                    <option *ngFor="let co of Component_help" [value]="co.id">{{ co.text }}</option>
                  </select>-->

                  <ng-select [items]="Component_help"
                             bindLabel="text"
                             bindValue="id"
                             formControlName="componentId"
                             [searchable]="true"
                             placeholder="--select--"
                             (change)="GetApprovedBudgetTargetMSME($event)">
                  </ng-select>

                  <div *ngIf="ImplementingAgencyDetailsFormSubmitted && f['componentId']['errors']" class="text-danger">
                    <div *ngIf="f['componentId'].errors['required']">Component is required</div>
                  </div>

                </div>
                <!--<div class="col-md-3">
                  <div class=" mb-4">
                    <label class="text-dark">Approved Budget</label>
                    <input type="text" (keypress)="numberOnly($event)" (paste)="onPaste($event)" [max]="maxBudget" formControlName="approved_Budget" placeholder="Approved Budget" class="form-control" />
                    <div *ngIf="ImplementingAgencyDetailsFormSubmitted && f['approved_Budget']['errors']"
                         class="text-danger">
                      <div *ngIf="f['approved_Budget'].errors['required']">Approved Budget is required</div>
                    </div>
                  </div>
                </div>-->
                <!--<div class="col-md-3">
                  <label for="durationEvent">Duration of Event<span class="text-danger">*</span></label>
                  <input type="number" class="form-control" formControlName="durationEvent" placeholder="Enter duration" min="1" max="7" (blur)="onBlurResetPeriod()" />-->
                <!-- Validation error messages -->
                <!--<div *ngIf="f['durationEvent'].invalid && isSubmitted" class="alert alert-danger required">
                    <div *ngIf="f['durationEvent'].errors && f['durationEvent'].errors['required']">
                      Duration of event is required.
                    </div>
                    <div *ngIf="f['durationEvent'].errors?.['min']">
                      Duration of event must be at least 1 day/hour.
                    </div>
                    <div *ngIf="f['durationEvent'].errors?.['max']">
                      Duration of event cannot exceed 7 days/hours.
                    </div>
                  </div>

                </div>-->

                <div class="col-md-3 mb-2">
                  <label class="text-dark">Target MSME<span class="text-danger">*</span><span class="txt-targetmsme text-info">&nbsp; {{ remainingTargetMSME }}</span></label>
                  <input type="number" (keypress)="numberOnly($event)" min="1" (paste)="onPaste($event)" (blur)="removeTargetValue()" [max]="maxMSME" formControlName="targetMSME" placeholder="Target MSME" class="form-control" />
                  <div *ngIf="ImplementingAgencyDetailsFormSubmitted && f['targetMSME'].invalid"
                       class="text-danger">
                    <div *ngIf="f['targetMSME'].errors?.['required']">Target MSME is required</div>
                    <div *ngIf="f['targetMSME'].errors?.['min']">
                      Minimum target value should not be less than 1
                    </div>
                    <div *ngIf="f['targetMSME'].hasError('max')" class="text-danger">
                      TargetMSME Value must not exceed {{ maxMSME }}
                    </div>
                  </div>
                </div>

                <div class="col-md-3 mb-2">
                  <label class="text-dark">Rate per Beneficiary MSME<span class="text-danger">*</span></label>
                  <input type="number"  (paste)="onPaste($event)" formControlName="rate_per_Beneficiary_MSME"
                         placeholder="Rate per Beneficiary MSME" class="form-control" />
                  <div *ngIf="ImplementingAgencyDetailsFormSubmitted && f['rate_per_Beneficiary_MSME'].invalid"
                       class="text-danger">
                    <div *ngIf="f['rate_per_Beneficiary_MSME'].errors?.['required']">Rate per Beneficiary MSME is required.</div>                    
                  </div>                
                </div>
                <div class="col-md-3 mb-2">
                  <label class="text-dark">No of Events<span class="text-danger">*</span></label>
                  <input type="text" (keypress)="numberOnly($event)" (paste)="onPaste($event)" formControlName="noOfEvent" placeholder="No of Events"
                         class="form-control" min="1" />
                  <div *ngIf="ImplementingAgencyDetailsFormSubmitted && f['noOfEvent']['errors']"
                       class="text-danger">
                    <div *ngIf="f['noOfEvent'].errors['required']">No of Events is required</div>
                    <div *ngIf="f['noOfEvent'].errors?.['min']">
                      Minimum no. value should not be less than 1
                    </div>
                    <div *ngIf="f['noOfEvent'].errors?.['maxlength']">
                      Maximum length is 3 number.
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 mb-2">
                  <label class="text-dark">Brief Background of the Implementing Agency<span class="text-danger">*</span></label>
                  <textarea type="text" rows="3" cols="50" formControlName="bbImplementAgency"
                            placeholder="Implementing Agency " class="form-control"></textarea>
                  <div *ngIf="ImplementingAgencyDetailsFormSubmitted && f['bbImplementAgency']['errors']"
                       class="text-danger">
                    <div *ngIf="f['bbImplementAgency'].errors['required']">
                      Implementing
                      Agency is required
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <label class="text-dark">Summary and scale of projects implemented in the last 3 years<span class="text-danger">*</span></label>
                  <textarea type="text" rows="3" cols="50"
                            formControlName="ssProjectImplementAgency"
                            placeholder="Summary and scale " class="form-control"></textarea>
                  <div *ngIf="ImplementingAgencyDetailsFormSubmitted && f['ssProjectImplementAgency']['errors']"
                       class="text-danger">
                    <div *ngIf="f['ssProjectImplementAgency'].errors['required']">
                      Summary and scale is required
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <label class="text-dark">Program For<span class="text-danger">*</span></label>
                  <textarea type="text" rows="3" cols="50" formControlName="pragramNameConduct" placeholder="Program For"
                            class="form-control"></textarea>
                  <div *ngIf="ImplementingAgencyDetailsFormSubmitted && f['pragramNameConduct']['errors']"
                       class="text-danger">
                    <div *ngIf="f['pragramNameConduct'].errors['required']">Program For is required</div>
                    <div *ngIf="f['pragramNameConduct'].errors['minlenfirstName']">Program For 1 characters</div>
                    <div *ngIf="f['pragramNameConduct'].errors?.['minlength']">
                      Minimum length is 3 characters.
                    </div>
                    <div *ngIf="f['pragramNameConduct'].errors?.['maxlength']">
                      Maximum length is 250 characters.
                    </div>
                    <div *ngIf="f['pragramNameConduct'].errors?.['pattern']">
                      The ampersand (&) symbol is not allowed. Please use valid characters.
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <label class="text-dark">Measurable Outcomes<span class="text-danger">*</span></label>
                  <textarea type="text" rows="3" cols="50" formControlName="measurableOutcomes" placeholder="Measurable Outcomes"
                            class="form-control"></textarea>
                  <div *ngIf="ImplementingAgencyDetailsFormSubmitted && f['measurableOutcomes']['errors']"
                       class="text-danger">
                    <div *ngIf="f['measurableOutcomes'].errors['required']">Measurable Outcomes is required</div>
                    <div *ngIf="f['measurableOutcomes'].errors?.['minlength']">Minimum length is 3 characters.</div>
                    <div *ngIf="f['measurableOutcomes'].errors?.['maxlength']">Maximum length is 250 characters.</div>
                    <div *ngIf="f['measurableOutcomes'].errors?.['pattern']"> The ampersand (&) symbol is not allowed. Please use valid characters.</div>
                    <!--<div *ngIf="f['measurableOutcomes'].errors?.['pattern']">Numeric values are not allowed.</div>-->
                  </div>
                </div>
              </div>
              <button (click)="Implementing_Agency_DetailsForm_submit()" class="btn btn-primary btn-Agency-details" [disabled]="isDisabled">Next ›</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Implementation Details -->
<section class="vh-100 gradient-custom right-side mt-5" *ngIf="currentStep === 2">
  <div class="container section">
    <h2>Implementation Details <cite title="Source Title"></cite></h2>
    <hr style="border-top: 2px solid goldenrod;" />
    <b class="text-danger">Note:* Add implementation Agency name in case Engagement Partnership is not applicable.</b>
    <div class="row">
      <div class="col-12 col-lg-12">
        <div class="shadow-2-strong card-registration">
          <div class="card-body p-4">

            <form [formGroup]="Implementation_Details">
              <div class="row">
                <div class="col-md-3">
                  <div class="mb-4">
                    <label class="text-dark">Engagement Partner Name<span class="text-danger">*</span></label>
                    <input type="text" formControlName="engagementPartnerName" placeholder="Engagement Partner Name"
                           class="form-control" (keypress)="restrictNumericInput($event)" value="EPN" trimValue (blur)="checkImplDetailsFields()" />
                    <div *ngIf="Implementation_DetailsSubmitted && k['engagementPartnerName']['errors']"
                         class="text-danger">
                      <div *ngIf="k['engagementPartnerName'].errors['required']">Engagement Partner Name is required</div>
                      <div *ngIf="k['engagementPartnerName'].errors?.['minlength']">Minimum length is 3 characters.</div>
                      <div *ngIf="k['engagementPartnerName'].errors?.['maxlength']">Maximum length is 150 characters.</div>
                      <div *ngIf="k['engagementPartnerName'].errors?.['pattern']">Only alphabetic characters are allowed.</div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-4">
                    <label class="text-dark">District<span class="text-danger">*</span></label>
                    <!--<select class="form-select" formControlName="districtId" (change)="checkImplDetailsFields()">
                      <option value="">-- Select District --</option>
                      <option *ngFor="let In of district_help" [value]="In.id">{{ In.text }}</option>
                    </select>-->
                    <ng-select [items]="district_help"
                               bindLabel="text"
                               bindValue="id"
                               formControlName="districtId"
                               [searchable]="true"
                               placeholder="--select--"
                               (change)="checkImplDetailsFields()">
                    </ng-select>

                    <div *ngIf="Implementation_DetailsSubmitted && k['districtId']['errors']"
                         class="text-danger">
                      <div *ngIf="k['districtId'].errors['required']">District is required</div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-4">
                    <label class="text-dark">No. of workshop<span class="text-danger">*</span></label>
                    <input type="number" (keypress)="numberOnly($event)" min="1" maxlength="3" (paste)="onPaste($event)" formControlName="noOfWorkshop" placeholder="No of workshop"
                           class="form-control" (blur)="checkImplDetailsFields()" />
                    <div *ngIf="Implementation_DetailsSubmitted && k['noOfWorkshop']['errors']" class="text-danger">
                      <!--<div *ngIf="!Implementation_Details_submitList.length">-->
                      <div *ngIf="k['noOfWorkshop'].errors['required']">No of workshop</div>
                      <div *ngIf="k['noOfWorkshop'].errors?.['min']">Minimum workshop value should not be less than 1.</div>
                      <div *ngIf="k['noOfWorkshop'].errors?.['maxlength']">Maximum length is 3 characters.</div>
                      <!--<div *ngIf="k['noOfWorkshop'].errors['minlenfirstName']">No of workshop</div>-->
                      <!--</div>-->
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-4">
                    <label class="text-dark">Target<span class="text-danger">*</span></label>
                    <input type="number" (keypress)="numberOnly($event)" min="1" [max]="maxTargetMSME" (paste)="onPaste($event)"
                           formControlName="targets" placeholder="Target" class="form-control" (blur)="checkImplDetailsFields()" />

                    <div *ngIf="isTarget">
                      <div *ngIf="Implementation_DetailsSubmitted && k['targets']['errors']" class="text-danger">
                        <!--<div *ngIf="!Implementation_Details_submitList.length">-->
                        <div *ngIf="k['targets'].errors['required']">Target is required</div>
                        <div *ngIf="k['targets'].errors?.['min']">
                          Minimum target value should not be less than 1
                        </div>
                        <div *ngIf="k['targets'].hasError('max')" class="text-danger">
                          Target value must not exceed {{ maxTargetMSME }}
                        </div>
                        <!--<div *ngIf="k['targets'].errors['minlenfirstName']">Target must be at least 1 characters</div>-->
                        <!--</div>-->
                      </div>
                      <div *ngIf="isTotalTargetMSMECount" class="text-info">
                        Total count target value is {{ TotalTargetMSMECount }} must not exceed by Target MSME value : {{ maxTargetMSME }}
                      </div>
                    </div>

                  </div>
                </div>
                <!--<div class="col-md-3">
                <div class="mb-4">
                  <label class="text-dark">Target<span class="text-danger">*</span></label>
                  <input type="text" (keypress)="numberOnly($event)" minlength="0" maxlength="5" (paste)="onPaste($event)" formControlName="targets" placeholder="Target" class="form-control" />
                  <div *ngIf="Implementation_DetailsSubmitted && k['targets']['errors']" class="text-danger">-->
                <!--<div *ngIf="!Implementation_Details_submitList.length">-->
                <!--<div *ngIf="k['targets'].errors['required']">Target is required</div>
                <div *ngIf="k['targets'].errors?.['minlength']">Minimum length is 1 characters.</div>
                <div *ngIf="k['targets'].errors?.['maxlength']">Maximum length is 5 characters.</div>-->
                <!--<div *ngIf="k['targets'].errors['minlenfirstName']">Target must be at least 1 characters</div>-->
                <!--</div>-->
                <!--</div>
                  </div>
                </div>-->
              </div>
              <div class="mt-2 pt-2">
                <a class="btn btn-primary mt-1" (click)="prev()">‹ Previous</a>
                <button (click)="Implementation_Details_submit('submit',0)" class="btn btn-primary mx-2 mt-1" [disabled]="isBtnNext">Next ›</button>
                <button (click)="Implementation_Details_submit('addmore',0)" class="btn btn-danger mt-1" [disabled]="isBtnAdd">+ Add </button>
              </div>
            </form>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table table-striped table-bordered table-hover">
            <thead>
              <tr>
                <th>Sr. No.</th>
                <th hidden class="border-top-0">Id</th>
                <th>Engagement Partner Name</th>
                <th>District</th>
                <th>No of workshop</th>
                <th>Target</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let sm of Implementation_Details_submitList; index as i">
                <td class="text-center">{{ i + 1 }}</td>
                <td hidden class="text-center">{{ sm.id }}</td>
                <td class="text-center">{{sm.engagementPartnerName}}</td>
                <td class="text-center">{{sm.districtName}}</td>
                <td class="text-center">{{sm.noOfWorkshop}}</td>
                <td class="text-center">{{sm.targets}}</td>
                <td class="text-center">
                  <button class="btn btn-primary btn-sm text-center me-2 mt-1" (click)="Implementation_Details_submit('edit',i)" [disabled]="isBtnEdit"><i class="bi bi-pencil"></i> Edit</button>
                  <button class="btn btn-danger btn-sm text-center mt-1" (click)="Implementation_Details_submit('delete',i)" [disabled]="isBtnDelete"><i class="bi bi-trash"></i> Delete</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>
  </div>
</section>

<!-- Geography and Timeline -->
<section class="vh-100 gradient-custom right-side mt-5" *ngIf="currentStep === 3">
  <div class="container section">
    <h2>Geography and Timeline <cite title="Source Title"></cite></h2>
    <hr style="border-top: 2px solid goldenrod;" />
    <div class="row">
      <div class="col-12 col-lg-12">
        <div class="shadow-2-strong card-registration">
          <div class="card-body p-4">

            <form [formGroup]="Geography_and_Timeline">
              <div class="row">
                <!--<div class="col-md-3">
                  <div class="mb-4">
                    <label class="text-dark">Proposed Date of Training<span class="text-danger">*</span></label>
                    <input type="date" formControlName="proposedDateTraining" placeholder="Details of Curriculum Design"
                           class="form-control" />
                    <div *ngIf="Geography_and_TimelineSubmitted && g['proposedDateTraining']['errors']"
                         class="text-danger">
                      <div *ngIf="g['proposedDateTraining'].errors['required']">
                        Proposed Date of Training is
                        required
                      </div>
                    </div>
                  </div>
                </div>-->
                <div class="col-md-3">
                  <label for="proposedDateTraining">Proposed Date of Training<span class="text-danger">*</span></label>
                  <!--<input class="form-control" placeholder="dd/mm/yyyy hh:mm" type="datetime-local" formControlName="eventDateTime" [min]="minDate" [max]="maxDate" (blur)="onBlurReset()" />-->
                  <!--<mat-form-field appearance="outline">-->
                  <input class="form-control proposedDateTraining" matInput
                         [matDatepicker]="startPicker"
                         placeholder="Proposed Date of Training"
                         formControlName="proposedDateTraining"
                         (focus)="startPicker.open()"
                         [value]="startDateTime | date: 'dd/MM/yyyy'"
                         [min]="minDate"
                         readonly />
                  <!--<mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>-->
                  <mat-datepicker #startPicker></mat-datepicker>
                  <!--</mat-form-field>-->
                  <!-- Validation error messages -->
                  <div *ngIf="Geography_and_TimelineSubmitted && g['proposedDateTraining']['errors']"
                       class="text-danger">
                    <div *ngIf="g['proposedDateTraining'].errors['required']">
                      Proposed Date of Training is
                      required
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-4">
                    <label class="text-dark">Proposed District<span class="text-danger">*</span></label>
                    <!--<select class="form-select" formControlName="proposedDistrict" (change)="checkGeoDetailsFields()">
                      <option value="">-- Select District --</option>
                      <option *ngFor="let In of district_help" [value]="In.id">{{ In.text }}</option>
                    </select>-->
                    <ng-select [items]="district_help"
                               bindLabel="text"
                               bindValue="id"
                               formControlName="proposedDistrict"
                               [searchable]="true"
                               placeholder="--select--"
                               (change)="checkGeoDetailsFields()">
                    </ng-select>
                    <div *ngIf="Geography_and_TimelineSubmitted && g['proposedDistrict']['errors']"
                         class="text-danger">
                      <!--<div *ngIf="!Geography_and_Timeline_submitList.length">-->
                      <div *ngIf="g['proposedDistrict'].errors['required']">District is required</div>
                      <!--</div>-->
                    </div>
                  </div>

                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label class="text-dark">Proposed Venue(Training location)<span class="text-danger">*</span></label>
                    <input type="text" formControlName="proposedVenue" placeholder="Proposed Venue"
                           class="form-control" trimValue (blur)="checkGeoDetailsFields()" />
                    <div *ngIf="Geography_and_TimelineSubmitted && g['proposedVenue']['errors']" class="text-danger">
                      <!--<div *ngIf="!Geography_and_Timeline_submitList.length">-->
                      <div *ngIf="g['proposedVenue'].errors['required']">Proposed Venue is required</div>
                      <div *ngIf="g['proposedVenue'].errors?.['minlength']">Minimum length is 3 characters.</div>
                      <div *ngIf="g['proposedVenue'].errors?.['maxlength']">Maximum length is 250 characters.</div>
                      <div *ngIf="g['proposedVenue'].errors?.['pattern']">The ampersand (&) symbol is not allowed. Please use valid characters.</div>
                      <!--</div>-->
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-4">
                    <label class="text-dark">Proposed No of workshop per location<span class="text-danger">*</span></label>
                    <input type="text" formControlName="proposedNoOfWorkshop" (keypress)="numberOnly($event)" (paste)="onPaste($event)"
                           placeholder="Proposed No of workshop per location" class="form-control" min="1" maxlength="3" (blur)="checkGeoDetailsFields()" />
                    <div *ngIf="Geography_and_TimelineSubmitted && g['proposedNoOfWorkshop']['errors']"
                         class="text-danger">
                      <!--<div *ngIf="!Geography_and_Timeline_submitList.length">-->
                      <div *ngIf="g['proposedNoOfWorkshop'].errors['required']">
                        Proposed No of workshop
                        per location is required
                      </div>
                      <div *ngIf="g['proposedNoOfWorkshop'].errors?.['min']">Minimum workshop should not be less than 1.</div>
                      <div *ngIf="g['proposedNoOfWorkshop'].errors?.['maxlength']">Maximum length is 3 number.</div>
                      <!--</div>-->
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-4">
                    <label class="text-dark">Total Target<span class="text-danger">*</span></label>
                    <input type="number" min="1" [max]="maxTargetMSME" (keypress)="numberOnly($event)" (paste)="onPaste($event)"
                           formControlName="totalTarget" placeholder="Total Target" class="form-control" (blur)="checkGeoDetailsFields()" />
                    <div *ngIf="isTargetGeo">
                      <div *ngIf="Geography_and_TimelineSubmitted && g['totalTarget']['errors']" class="text-danger">
                        <!--<div *ngIf="!Geography_and_Timeline_submitList.length">-->
                        <div *ngIf="g['totalTarget'].errors['required']">Total Target is required</div>
                        <div *ngIf="g['totalTarget'].errors?.['min']">
                          Minimum Total Target should not be less than 1
                        </div>
                        <div *ngIf="g['totalTarget'].hasError('max')" class="text-danger">
                          Total Target value must not exceed {{ maxTargetMSME }}
                        </div>
                      </div>
                      <div *ngIf="isTotalTargetMSMECount" class="text-info">
                        Total count target value is {{ TotalTargetMSMECount }} must not exceed by Target MSME value : {{ maxTargetMSME }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-4">
                <a class="btn btn-primary mt-1" (click)="prev()">‹ Previous</a>
                <button (click)="Geography_and_Timeline_submit('submit',0)" class="btn btn-primary mx-2 mt-1" [disabled]="isBtnNextGeo">Next ›</button>
                <button (click)="Geography_and_Timeline_submit('addmore',0)" class="btn btn-danger mt-1" [disabled]="isBtnAddGeo">+ Add </button>
              </div>
            </form>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table table-striped table-bordered table-hover">
            <thead>
              <tr>
                <th>Sr. No.</th>
                <th hidden class="border-top-0">Id</th>
                <th>Proposed Date of Training</th>
                <th>Proposed District</th>
                <th>Proposed Venue</th>
                <th>Proposed No Of Workshop Per Location</th>
                <th>Total Target</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let sm of Geography_and_Timeline_submitList; index as i">
                <td class="text-center">{{ i + 1 }}</td>
                <td hidden class="text-center">{{ sm.id }}</td>
                <td class="text-center">{{sm.proposedDateTraining}}</td>
                <td class="text-center">{{sm.districtName}}</td>
                <td class="text-center">{{sm.proposedVenue}}</td>
                <td class="text-center">{{sm.proposedNoOfWorkshop}}</td>
                <td class="text-center">{{sm.totalTarget}}</td>
                <td class="text-center">
                  <button class="btn btn-primary btn-sm text-center mt-1 me-2" (click)="Geography_and_Timeline_submit('edit',i)" [disabled]="isBtnEdit"><i class="bi bi-pencil"></i> Edit</button>
                  <button class="btn btn-danger btn-sm text-center mt-1" (click)="Geography_and_Timeline_submit('delete',i)" [disabled]="isBtnDelete"><i class="bi bi-trash"></i> Delete</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>
  </div>
</section>

<!-- Training Delivery, Beneficiaries and Certification-->
<section class="vh-100 gradient-custom right-side mt-5" *ngIf="currentStep === 4">
  <div class="container section">
    <h2>Training Delivery, Beneficiaries and Certification <cite title="Source Title"></cite></h2>
    <hr style="border-top: 2px solid goldenrod;" />
    <div class="row">
      <div class="col-12 col-lg-12">
        <div class="shadow-2-strong card-registration">
          <div class="card-body p-4">
            <form [formGroup]="Training_Delivery">
              <div class="row">
                <div class="col-md-12">
                  <div class="mb-4">
                    <label class="text-dark">Details of Curriculum Design/ Course Content<span class="text-danger">*</span></label>
                    <textarea type="text" rows="3" cols="50" formControlName="detailsCDCC"
                              placeholder="Details of Curriculum Design" class="form-control" trimValue></textarea>
                    <div *ngIf="Training_DeliverySubmitted && t['detailsCDCC']['errors']"
                         class="text-danger">
                      <div *ngIf="t['detailsCDCC'].errors['required']">Details of Curriculum Design is required</div>
                      <div *ngIf="t['detailsCDCC'].errors?.['minlength']">Minimum length is 3 characters.</div>
                      <!--<div *ngIf="t['detailsCDCC'].errors?.['maxlength']">Maximum length is 2000 characters.</div>-->
                      <!--<div *ngIf="t['detailsCDCC'].errors?.['pattern']">Only special characters are not allowed.</div>-->
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div class="mb-4">
                    <label class="text-dark">Duration of Workshop (Hours) for each category<span class="text-danger">*</span></label>
                    <input type="text" min="1" maxlength="2" (keypress)="numberOnly($event)" (paste)="onPaste($event)" formControlName="durationWorkshop" placeholder="Duration of Workshop"
                           class="form-control" />
                    <div *ngIf="Training_DeliverySubmitted && t['durationWorkshop']['errors']" class="text-danger">
                      <div *ngIf="t['durationWorkshop'].errors['required']">Duration of Workshop is required</div>
                      <div *ngIf="t['durationWorkshop'].errors?.['min']">Minimum duration value should not be less than 1 hours.</div>
                      <div *ngIf="t['durationWorkshop'].errors?.['maxlength']">Maximum 2 digit.</div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-4">
                    <label class="text-dark">Qualification of Trainers<span class="text-danger">*</span></label>
                    <input type="text" formControlName="qualificationTrainers"
                           placeholder="Qualification of Trainers" class="form-control" (keypress)="restrictNumericInput($event)" trimValue />
                    <div *ngIf="Training_DeliverySubmitted && t['qualificationTrainers']['errors']"
                         class="text-danger">
                      <div *ngIf="t['qualificationTrainers'].errors['required']">
                        Qualification of Trainers is
                        required
                      </div>
                      <div *ngIf="t['qualificationTrainers'].errors?.['minlength']">Minimum length is 3 characters.</div>
                      <div *ngIf="t['qualificationTrainers'].errors?.['maxlength']">Maximum length is 150 characters.</div>
                      <div *ngIf="t['qualificationTrainers'].errors?.['pattern']">Only alphabetic characters are allowed.</div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-4">
                    <label class="text-dark">Beneficiaries<span class="text-danger">*</span></label>
                    <!--<select class="form-select" formControlName="beneficiariesId">
                      <option value="">-- Select Beneficiaries --</option>
                      <option value="1">MSME</option>
                      <option value="2">Entrepreneur</option>
                      <option value="3">MSME Employee</option>
                      <option value="4">MEME Aspirant</option>
                    </select>-->
                    <ng-select [items]="beneficiariesList"
                               bindLabel="text"
                               bindValue="value"
                               formControlName="beneficiariesId"
                               [searchable]="true"
                               placeholder="--select--">
                    </ng-select>
                    <div *ngIf="Training_DeliverySubmitted && t['beneficiariesId']['errors']"
                         class="text-danger">
                      <div *ngIf="t['beneficiariesId'].errors['required']">Beneficiaries is required</div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4 d-none">
                  <div class="mb-4">
                    <label class="text-dark">Proposed certification for workshops<span class="text-danger">*</span></label>
                    <input type="text" min="1" maxlength="3" (keypress)="numberOnly($event)" (paste)="onPaste($event)" formControlName="proposedCertificationWorkshops" value="1"
                           placeholder="Proposed Certification for Workshops" class="form-control" />
                    <div *ngIf="Training_DeliverySubmitted && t['proposedCertificationWorkshops']['errors']"
                         class="text-danger">
                      <div *ngIf="t['proposedCertificationWorkshops'].errors['required']">Proposed certification for workshops is required</div>
                      <div *ngIf="t['proposedCertificationWorkshops'].errors?.['min']">Minimum workshops value should not be less than 1.</div>
                      <div *ngIf="t['proposedCertificationWorkshops'].errors?.['maxlength']">Maximum length is 3 characters.</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-4">
                <a class="btn btn-primary mt-1" (click)="prev()">‹ Previous</a>
                <a (click)="Training_Delivery_submit()" class="btn btn-primary mt-1 mx-2">Next ›</a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--DetailedFinancials (Cost Bifurcation for each workshop/training)-->
<section class="vh-100 gradient-custom right-side mt-5" *ngIf="currentStep === 5">
  <div class="container section">
    <h2>Detailed Financials (Cost Bifurcation for each workshop/training) <cite title="Source Title"></cite></h2>
    <hr style="border-top: 2px solid goldenrod;" />
    <div class="row">
      <div class="col-12 col-lg-12">
        <div class="shadow-2-strong card-registration">
          <div class="card-body p-4">
            <form [formGroup]="DetailedFinancials">
              <div class="row">
                <div class="col-md-4">
                  <div class="mb-4">
                    <label class="text-dark">Budget Head<span class="text-danger">*</span></label>
                    <select class="form-select" formControlName="budgetHeadId" (change)="checkDetailedFinancialsFields()">
                      <option value="">-- Select Budget Head --</option>
                      <option *ngFor="let bh of budgetHead_help" [value]="bh.id">{{ bh.text }}</option>
                    </select>
                    <div *ngIf="DetailedFinancialsSubmitted && b['budgetHeadId']['errors']"
                         class="text-danger">
                      <!--<div *ngIf="!DetailedFinancials_submitList.length">-->
                      <div *ngIf="b['budgetHeadId'].errors['required']">Beneficiaries is required.</div>
                      <!--</div>-->
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-4">
                    <label class="text-dark">Cost<span class="text-danger">*</span></label>
                    <input type="number" min="1" (keypress)="numberOnly($event)" [max]="maxCost" (paste)="onPaste($event)" formControlName="cost"
                           placeholder="Cost" class="form-control" (blur)="checkDetailedFinancialsFields()" />
                    <div *ngIf="DetailedFinancialsSubmitted && b['cost']['errors']"
                         class="text-danger">
                      <div *ngIf="b['cost'].errors['required']">Cost is required.</div>
                      <div *ngIf="b['cost'].errors['min']">Minimum cost value should not be less than 1.</div>
                      <div *ngIf="b['cost'].hasError('max')" class="text-danger">
                        Cost value must not exceed {{ maxCost }}
                      </div>
                      <!--<div *ngIf="b['cost'].errors['maxlength']">Maximum length is 4 cost.</div>-->
                      <!--<div *ngIf="!DetailedFinancials_submitList.length">-->
                      <!--<div *ngIf="b['cost'].errors['required']">Cost is required.</div>
                      <div *ngIf="b['cost'].errors?.['minlength']">Minimum length is 1 cost.</div>
                      <div *ngIf="b['cost'].errors?.['maxlength']">Maximum length is 5 cost.</div>-->
                      <!--</div>-->
                    </div>
                  </div>
                </div>

              </div>
              <div class="mt-4">
                <a class="btn btn-primary mt-1" (click)="prev()">‹ Previous</a>
                <button (click)="DetailedFinancials_Submit('submit',0)" class="btn btn-primary mt-1 mx-2">Next ›</button>
                <button (click)="DetailedFinancials_Submit('addmore',0)" class="btn btn-danger mt-1 d-none">+ Add </button>
              </div>
            </form>
          </div>
        </div>
        <div class="table-responsive d-none">
          <table class="table table-striped table-bordered table-hover">
            <thead>
              <tr>
                <th>Sr. No.</th>
                <th hidden class="border-top-0">Id</th>
                <th>Budget Head</th>
                <th>Cost</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let kl of DetailedFinancials_submitList; index as i">
                <td class="text-center">{{ i + 1 }}</td>
                <td hidden class="text-center">{{ kl.id }}</td>
                <td class="text-center">{{kl.interventionName}}</td>
                <td class="text-center">{{kl.cost}}</td>
                <td class="text-center">
                  <button class="btn btn-primary btn-sm text-center mt-1 me-2" (click)="DetailedFinancials_Submit('edit',i)" [disabled]="isBtnEdit"><i class="bi bi-pencil"></i> Edit</button>
                  <button class="btn btn-danger btn-sm text-center mt-1" (click)="DetailedFinancials_Submit('delete',i)" [disabled]="isBtnDelete"><i class="bi bi-trash"></i> Delete</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</section>

<!--Intervention MilestonesForm-->
<section class="vh-100 gradient-custom right-side mt-5" *ngIf="currentStep === 6">
  <div class="container section">
    <h2>Intervention Milestones Form <cite title="Source Title"></cite></h2>
    <hr style="border-top: 2px solid goldenrod;" />
    <div class="row">
      <div class="col-12 col-lg-12">
        <div class="shadow-2-strong card-registration">
          <div class="card-body p-4">
            <form [formGroup]="Intervention_MilestonesForm">
              <div class="row">
                <div class="col-md-9">
                  <div class="mb-4">
                    <label class="text-dark">Milestone<span class="text-danger">*</span></label>
                    <!--<input type="text" formControlName="milestone" placeholder="Milestone" class="form-control" (blur)="checkFields()" trimValue readonly />-->
                    <input type="text" formControlName="milestone" placeholder="Milestone" class="form-control" trimValue readonly />
                    <div *ngIf="Intervention_MilestonesSubmitted && m['milestone']['errors']" class="text-danger">
                      <div *ngIf="m['milestone'].errors['required']">Milestone is required</div>
                      <div *ngIf="m['milestone'].errors?.['minlength']">Minimum length is 1 characters.</div>
                      <div *ngIf="m['milestone'].errors?.['maxlength']">Maximum length is 150 characters.</div>
                      <div *ngIf="m['milestone'].errors?.['pattern']">Only letters, numbers, and spaces are allowed.</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <div class="mb-4">
                    <label for="projectStartDate">Project Start Date<span class="text-danger">*</span></label>
                    <!--<input class="form-control" placeholder="dd/mm/yyyy hh:mm" type="datetime-local" formControlName="eventDateTime" [min]="minDate" [max]="maxDate" (blur)="onBlurReset()" />-->
                    <!--<mat-form-field appearance="outline">-->
                    <input class="form-control projectStartDate" matInput
                           [matDatepicker]="startPicker"
                           placeholder="Project Start Date"
                           formControlName="projectStartDate"
                           [value]="startDateTime | date: 'dd/MM/yyyy'"
                           (focus)="startPicker.open()"
                           [min]="proposalStartDate"
                           readonly
                           (dateChange)="onProjectStartDateChange($event)" />
                    <!--<mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>-->
                    <mat-datepicker #startPicker></mat-datepicker>
                    <!--</mat-form-field>-->
                    <!-- Validation error messages -->
                    <div *ngIf="Intervention_MilestonesSubmitted && m['projectStartDate']['errors']"
                         class="text-danger">
                      <div *ngIf="m['projectStartDate'].errors['required']">Project Start Date is required</div>
                    </div>
                  </div>

                </div>
                <div class="col-md-3">
                  <div class="mb-4">
                    <label class="text-dark">Duration in months<span class="text-danger">*</span></label>
                    <!--<input type="text" formControlName="durationInMonth"
         placeholder="Duration in months" min="1" maxlength="2" class="form-control" (keypress)="numberOnly($event)" (blur)="checkFields()" />-->
                    <input type="text" formControlName="durationInMonth"
                           placeholder="Duration in months" min="1" maxlength="2" class="form-control" (keypress)="numberOnly($event)" />
                    <div *ngIf="Intervention_MilestonesSubmitted && m['durationInMonth']['errors']"
                         class="text-danger">
                      <div *ngIf="m['durationInMonth'].errors['required']">
                        Duration in months is required
                      </div>
                      <div *ngIf="m['durationInMonth'].errors?.['min']">Minimum duration month should not be less than 1.</div>
                      <div *ngIf="m['durationInMonth'].errors?.['maxlength']">Maximum length is 2 characters.</div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-4">
                    <label for="estimatedProjectClosure">Estimated Project Closure Date<span class="text-danger">*</span></label>
                    <input class="form-control estimatedProjectClosure" matInput
                           [matDatepicker]="startepcPicker"
                           placeholder="Estimated Project Closure Date"
                           formControlName="estimatedProjectClosure"
                           (focus)="startepcPicker.open()"
                           [value]="startDateTime | date: 'dd/MM/yyyy'"
                           [min]="proposalSelectedDate"
                           readonly />
                    <!--<mat-datepicker-toggle matSuffix [for]="startepcPicker"></mat-datepicker-toggle>-->
                    <mat-datepicker #startepcPicker></mat-datepicker>
                    <div *ngIf="Intervention_MilestonesSubmitted && m['estimatedProjectClosure']['errors']"
                         class="text-danger">
                      <div *ngIf="m['estimatedProjectClosure'].errors['required']">Estimated project Closure Date is required</div>
                    </div>
                  </div>
                </div>
                <!--<div class="col-md-3">
                  <label for="uploadProposalCertificate">Upload Proposal (PDF, max 10 MB)<span class="text-danger">*</span></label>
                  <input type="file" class="form-control" id="uploadProposalCertificate" (change)="onUploadProposalFileChange($event)" accept=".pdf" [disabled]="isUploadProposalCertificate" />
                  <div *ngIf="Intervention_MilestonesSubmitted && m['uploadProposalCertificate']['errors']"
                       class="text-danger">
                    <div *ngIf="m['uploadProposalCertificate'].errors['required']">File is required.</div>
                  </div>
                  <div *ngIf="uploadError" class="text-danger">{{ uploadError }}</div>
                  <div class="mt-2">
                    <p *ngIf="fileName"><strong>Uploaded File:</strong> {{ fileName }}</p>
                    <button type="button" class="btn btn-primary btn-sm" (click)="openFile()" [disabled]="!fileUrl"> <i class="bi bi-eye"></i> View</button>
                  </div>
                </div>-->
                <div class="col-md-3">
                  <label for="uploadProposalCertificate">Upload Proposal (PDF, max 10 MB)<span class="text-danger">*</span></label>
                  <input type="file" class="form-control" id="uploadProposalCertificate"
                         (change)="onUploadProposalFileChange($event)"
                         accept=".pdf"
                         [disabled]="isUploadProposalCertificate" />
                  <div *ngIf="Intervention_MilestonesSubmitted && m['uploadProposalCertificate']['errors']" class="text-danger">
                    <!-- Required File Validation -->
                    <div *ngIf="Intervention_MilestonesForm.get('uploadProposalCertificate')?.errors?.['required']" class="text-danger">
                      File is required.
                    </div>

                    <!-- File Type Validation -->
                    <div *ngIf="Intervention_MilestonesForm.get('uploadProposalCertificate')?.errors?.['invalidType']" class="text-danger">
                      Only PDF files are allowed.
                    </div>

                    <!-- File Size Validation -->
                    <div *ngIf="Intervention_MilestonesForm.get('uploadProposalCertificate')?.errors?.['maxSize']" class="text-danger">
                      File size should not exceed 10MB.
                    </div>
                  </div>
                  <div class="mt-2">
                    <p *ngIf="fileName"><strong>Uploaded File:</strong> {{ fileName }}</p>
                    <button type="button" class="btn btn-primary btn-sm" (click)="openFile()" [disabled]="!fileUrl">
                      <i class="bi bi-eye"></i> View
                    </button>
                  </div>
                </div>
              </div>
              @if(proposalUserId){
              <div class="col-md-3 mt-4">
                <a class="text-decoration-none btn btn-warning btn-sm"
                   *ngIf="uploadProposalPathData"
                   (click)="onDownload(uploadProposalPathData, uploadProposalDocumentData); $event.preventDefault()"
                   style="text-decoration: underline; cursor: pointer">
                  <i class="bi bi-download"></i> Download Proposal Document
                </a>
              </div>
              }
              <div class="mt-4">
                <a class="btn btn-primary mt-1" (click)="prev()">‹ Previous</a>
                @if(proposalUserId){
                <button (click)="Intervention_Milestones_submit('submit',0)" class="btn btn-success mt-1 mx-2" [disabled]="isHiddenUpdate">Update ›</button>
                }
                @else{
                <button (click)="Intervention_Milestones_submit('submit',0)" class="btn btn-success mt-1 mx-2" [disabled]="isHiddenSubmit">Submit ›</button>
                }

                <!--[disabled]="isHiddenSubmit"-->
                <!--<button (click)="Intervention_Milestones_submit('addmore',0)" class="btn btn-danger mt-1" [disabled]="isBtnAddMile">+ Add </button>-->
              </div>

            </form>
          </div>
        </div>

        <div class="table-responsive">
          <table class="table table-striped table-bordered table-hover">
            <thead>
              <tr>
                <th>Sr. No.</th>
                <th hidden class="border-top-0">Id</th>
                <th>Milestone</th>
                <th>Project Start Date</th>
                <th>Duration in Months</th>
                <th>Estimated Project Closure Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let sm of Intervention_Milestones_submitList; index as i">
                <td class="text-center">{{ i + 1 }}</td>
                <td hidden class="text-center">{{ sm.id }}</td>
                <td class="text-center">{{sm.milestone}}</td>
                <td class="text-center">{{sm.projectStartDate}}</td>
                <td class="text-center">{{sm.durationInMonth}}</td>
                <td class="text-center">{{sm.estimatedProjectClosure}}</td>
                <td class="text-center">
                  <button class="btn btn-primary btn-sm text-center mt-1 me-2" (click)="Intervention_Milestones_submit('edit',i)" [disabled]="isBtnEdit"><i class="bi bi-pencil"></i> Edit</button>
                  <button class="btn btn-danger btn-sm text-center mt-1" (click)="Intervention_Milestones_submit('delete',i)" [disabled]="isBtnDelete"><i class="bi bi-trash"></i> Delete</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>
  </div>
</section>
